/**
 * FO 헤더 네비게이션 선언 배열 SSoT(정적 SPA — DB 메뉴 아님).
 * 헤더 항목을 선언적으로 정의해 마크업 수정 없이 배열 1행 추가로 확장. 인증 수준·배치 슬롯으로 토글.
 *
 * auth 노출 규칙: 'always' 전부 / 'guest' 비로그인만 / 'authed' 로그인만
 */
import type { ButtonProps } from '@/components/ui/button';
import { landingAnchorRoute } from '@/config/landingAnchors';
import { ROUTES } from '@/config/routes';

export type NavAuth = 'always' | 'guest' | 'authed';
/** 배치 슬롯 — menu(좌측 GNB 텍스트 링크) / action(우측 액션 버튼·링크). */
export type NavSlot = 'menu' | 'action';

export interface NavItem {
  label: string;
  auth: NavAuth;
  slot: NavSlot;
  /** 슬롯 내 정렬 순서(오름차순). */
  order: number;
  /** 내부 route. action 항목엔 없음. */
  route?: string;
  /** 요금제 노출 시에만 보임 — 베타 무료 기간에는 숨긴다(판단 SSoT `usePricingVisible`). */
  pricing?: true;
  /** 액션 항목(route 없음) — logout 등. FoHeader 가 kind 로 핸들러 분기. */
  kind?: 'logout';
  /** action 슬롯 버튼 시각(Button variant) — 미지정 시 ghost(텍스트형). */
  button?: ButtonProps['variant'];
}

export const HEADER_NAV: readonly NavItem[] = [
  // 공개 화면(specs/070 · ux-spec A1) — 둘러보기·올해 꼭 보는 사업·기업 인증 안내 + 요금제(랜딩 앵커). 홈은 로고가 담당한다.
  {
    label: '지원사업 둘러보기',
    route: ROUTES.programs,
    auth: 'always',
    slot: 'menu',
    order: 10,
  },
  {
    label: '올해 꼭 보는 사업',
    route: ROUTES.featured,
    auth: 'always',
    slot: 'menu',
    order: 20,
  },
  {
    label: '기업 인증 안내',
    route: ROUTES.certifications,
    auth: 'always',
    slot: 'menu',
    order: 30,
  },
  {
    label: '요금제',
    route: landingAnchorRoute('pricing'),
    auth: 'always',
    pricing: true,
    slot: 'menu',
    order: 40,
  },
  {
    label: '로그인',
    route: ROUTES.login,
    auth: 'guest',
    slot: 'action',
    order: 10,
    button: 'outline',
  },
  {
    label: '무료로 시작하기',
    route: ROUTES.signup,
    auth: 'guest',
    slot: 'action',
    order: 20,
    button: 'default',
  },
  {
    label: '워크스페이스 가기',
    route: ROUTES.workspace.root,
    auth: 'authed',
    slot: 'action',
    order: 10,
    button: 'default',
  },
  { label: '로그아웃', kind: 'logout', auth: 'authed', slot: 'action', order: 20 },
] as const;
